
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    export class ECommOrderLaborGrid extends Serenity.EntityGrid<ECommOrderLaborRow, any> {
        protected getColumnsKey() { return 'ECommerce.OrderLabor'; }
        protected getIdProperty() { return ECommOrderLaborRow.idProperty; }
        protected getInsertPermission() { return ECommOrderLaborRow.insertPermission; }
        protected getLocalTextPrefix() { return ECommOrderLaborRow.localTextPrefix; }
        protected getService() { return ECommOrderLaborService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}